<template>
    <vx-table-row>
        <vx-table-row-title class="xl:col-span-2!">
            {{ props.modelValue.name }}
        </vx-table-row-title>

        <vx-table-row-item data-test="team-names">
            <template v-slot:label> Teams: </template>
            <vx-popover> </vx-popover>

            <vx-popover v-if="teamNames.length" hover :arrow="true" placement="top" class="max-w-sm">
                <button
                    type="button"
                    class="block max-w-full text-left focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
                    data-test="team-list"
                >
                    <span class="line-clamp-3">{{ teamNames.slice(0, 5).join(', ') }}</span>
                </button>
                <template v-slot:content>
                    <div class="max-w-md flex items-center gap-2 flex-wrap">
                        Teams:
                        <vx-badge v-for="(teamName, index) in teamNames" :key="`${teamName}-${index}`" size="sm">
                            {{ teamName }}
                        </vx-badge>
                    </div>
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-dropdown placement="right">
                <vx-button data-test="dropdown" type="button" color="muted" outline class="w-[45px]">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item data-test="delete" @click="destroy">
                        Delete
                        <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button
                @click.prevent="emit('edit', props.modelValue)"
                :data-test="`edit-button`"
                color="muted"
                class="w-full sm:w-auto"
                outline
            >
                Edit <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script setup>
import {
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxPopover,
    VxBadge,
} from '@voxie/frontend-components';
import { faEllipsis, faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { adminCloningTargetsClient } from '~/services/index';
import { throwSwalRequestError } from '~/utils/request';
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['deleted', 'edit']);

const teamNames = computed(() => props.modelValue.teams.map((team) => team.name));

const destroy = () => {
    VxSwal.fire({
        title: 'Delete Target',
        text: 'Are you sure? There is no undo.',
        icon: 'danger',
        showCancelButton: true,
        confirmButtonColor: 'danger',
        preConfirm: () =>
            adminCloningTargetsClient
                .deleteCloningTarget(props.modelValue.id)
                .then(() => emit('deleted', props.modelValue.id))
                .catch(throwSwalRequestError),
    });
};
</script>
